const stationObservationExchangeList = () => import('Views/stationObservationExchange/stationObservationExchange-list-new-ui');
const stationObservationExchangeMetaData = () => import('Views/stationObservationExchange/stationObservationExchange-metaData-new-ui');

export default[
  { path: '/station-observation-exchange-list', component: stationObservationExchangeList },
  { path: '/station-observation-exchange-metaData/:id', component: stationObservationExchangeMetaData },
];



// WEBPACK FOOTER //
// ./src/router/stationObservationExchange.js